var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BetaToggle from 'components/beta/BetaToggle.vue';
var beta = namespace('beta');
var BetaSidebarButton = /** @class */ (function (_super) {
    __extends(BetaSidebarButton, _super);
    function BetaSidebarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BetaSidebarButton.prototype, "shouldUpdateBetas", {
        get: function () {
            return this.userBetas.some(function (beta) { return beta.isChanged === true; });
        },
        enumerable: false,
        configurable: true
    });
    BetaSidebarButton.prototype.updateBetas = function () {
        this.updateUserBetas();
        this.$notify.toast(this.$t('ats.beta.success'), { type: 'success' });
    };
    __decorate([
        beta.State,
        __metadata("design:type", Array)
    ], BetaSidebarButton.prototype, "userBetas", void 0);
    __decorate([
        beta.State,
        __metadata("design:type", Boolean)
    ], BetaSidebarButton.prototype, "loading", void 0);
    __decorate([
        beta.Action,
        __metadata("design:type", Function)
    ], BetaSidebarButton.prototype, "updateUserBetas", void 0);
    BetaSidebarButton = __decorate([
        Component({
            components: { BetaToggle: BetaToggle },
            beforeDestroy: function () {
                if (this.shouldUpdateBetas) {
                    this.updateBetas();
                }
            },
        })
    ], BetaSidebarButton);
    return BetaSidebarButton;
}(Vue));
export default BetaSidebarButton;
